import * as React from "react";
const SvgGreenCurrency = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.918 14.157c0 1.195.917 2.158 2.056 2.158h2.324c.991 0 1.797-.843 1.797-1.88 0-1.13-.491-1.528-1.223-1.787l-3.731-1.296c-.732-.26-1.223-.658-1.223-1.788 0-1.037.806-1.88 1.797-1.88h2.324c1.14 0 2.056.964 2.056 2.158M12 6.444v11.112M21.26 12a9.26 9.26 0 1 1-18.52 0 9.26 9.26 0 0 1 18.52 0"
    />
  </svg>
);
export default SvgGreenCurrency;
